import React, { useState } from "react";
import styled from "styled-components";
import useWindowDimensions from "../constatns/size";

import "../styles/home.css";
function PartnersCard({image, logoStyle}) {
    const { width, height } = useWindowDimensions();
    const [value, setValue] = useState(0);
  return (
    <Container width={width} height={height} id="eccosystem">
        <CardImage alt={image} width={width} height={height} style={logoStyle} src={image} />
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    background-color: #1F2450;
    width: ${({width})=> width * 0.2}px;
    height: ${({height})=> height * 0.2}px;
    border-radius: 10px;
    margin-left: 30px;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;

    @media (max-width: 768px) {
      width: ${({width})=> width * 0.8}px;
      height: ${({height})=> height * 0.4}px;
      margin-left: 0px;

    }
`

const CardImage = styled.img`
    width: ${({width})=> width * 0.15}px;
    height: ${({height})=> height * 0.15}px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;

    @media (max-width: 768px) {
      width: ${({width})=> width * 0.6}px;
      height: ${({height})=> height * 0.15}px;
    }
`


export default PartnersCard;
